// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Banner_imageWrapper__3I_0l","bannerInContent":"Banner_bannerInContent__1E1pS"};